import axios from 'axios';
import config from './config';

const API_BASE_URL = `${config.API_BASE_URL}`;

export const fetchProductsByCategory = async (categoryId, branchId) => {
  let url = `${API_BASE_URL}/Product?categoryId=${categoryId}`;
  if (branchId) {
    url += `&branchId=${branchId}`;
  }
  const response = await axios.get(url);
  return response.data;
};

export const createOffer = async (offerData) => {
  const response = await axios.post(`${API_BASE_URL}/offers`, offerData);
  return response.data;
};
